var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('citation-card');
import { breakpoints } from '@shapeable/theme';
import { CitationCell } from './citation-cell';
import { EntityTextValue } from './entity-text-value';
import { EntityTextValueList } from './entity-text-value-list';
import { useEntity } from '../../hooks/use-entity';
import { useLang } from '../../hooks/use-lang';
import { EntityCard } from './entity-card';
export var CitationCardDefaultProps = {
  label: "Scientific Paper"
}; // -------- Styles -------->

var CardStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkedStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkedListStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CellStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    a {\n      word-break: break-all; \n    }\n  "], ["\n    a {\n      word-break: break-all; \n    }\n  "])))
}); // -------- Components -------->

var My = {
  Card: styled(EntityCard)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Linked: styled(EntityTextValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LinkedStyles),
  LinkedList: styled(EntityTextValueList)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkedListStyles),
  Cell: styled(CitationCell)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), CellStyles)
};
export var CitationCard = function CitationCard(props) {
  var className = props.className,
      children = props.children,
      label = props.label,
      rest = __rest(props, ["className", "children", "label"]);

  var entity = useEntity(props.entity);
  var t = useLang();
  return React.createElement(My.Card, __assign({}, rest, {
    spaceUnits: 0,
    href: entity.url || "",
    target: "_blank",
    label: label,
    className: cls.name(className)
  }), React.createElement(My.Cell, {
    entity: entity,
    isExtended: true
  }), children);
};
CitationCard.defaultProps = CitationCardDefaultProps;
CitationCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;